// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getGalleryMedia } from "./actions/get-gallery-media.action";
import { getAlbums } from "./actions/get-albums.action";

// ############################################################

// Initial state
const initialState = {
	media: {
		loading: true,
		items: [],
		pagination: {
			currentPage: 1,
			first: 1,
			totalPages: 1,
		},
		paginationHash: {},
		total: 0,
	},
	albums: {
		loading: true,
		items: [],
	},
};

// ############################################################

// Slice
const userpanelGalleryAndPostsSlice = createSlice({
	name: "userpanel/galleryAndPosts",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getMedia
			.addCase(getGalleryMedia.pending, (state) => {
				state.media.loading = true;
			})
			.addCase(getGalleryMedia.fulfilled, (state, action) => {
				state.media.loading = false;
				state.media.items = action.payload.data.media;
				state.media.pagination.currentPage =
					action.payload.data.pagination.currentpage;
				state.media.pagination.totalPages =
					action.payload.data.pagination.totalpages;
				state.media.pagination.first =
					action.payload.data.pagination.first;
				state.media.paginationHash = action.payload.data.paginationHash;
				state.media.total = action.payload.data.total;
			})
			.addCase(getGalleryMedia.rejected, (state) => {
				state.media.loading = false;
			})
			// getAlbums
			.addCase(getAlbums.pending, (state) => {
				state.albums.loading = true;
			})
			.addCase(getAlbums.fulfilled, (state, action) => {
				state.albums.loading = false;
				state.albums.items = action.payload.data;
			})
			.addCase(getAlbums.rejected, (state) => {
				state.albums.loading = false;
			});
	},
});

// ############################################################

export const { resetGallery } = userpanelGalleryAndPostsSlice.actions;

export default userpanelGalleryAndPostsSlice.reducer;

// ############################################################
